import { useState as State , useEffect as Fx } from "react";
import Splash from "./Splash";
import Main from "./Main";

const Interface = () => {

    const [ Loading , Set ] = State(true);
    
    Fx(
        () => {
            setTimeout(
                () => {
                    Set(false);
                }, 5000
            );
        } , [ Loading ]
    );

    return(
        <section className="Interface" >
            {
                Loading ? <Splash /> : <Main />
            }
        </section>
    );

};

export default Interface;